<div class="file-upload__preview">
    <div class="file-upload__preview__image" *ngIf="hasPreview && hasPreviewAsImage">
        <img [src]="previewData.display" *ngIf="url && previewData.image">
        <i class="fa {{ previewData.display }}" *ngIf="previewData && !previewData.image"></i>
    </div>
    <div class="file-upload__preview__icon" *ngIf="hasPreview && hasPreviewAsIcon">
        <span class="eui-icon eui-icon-color {{ icon }}" euiIconColored euiSize5XL></span>
    </div>
    <div class="file-upload__preview__filename" *ngIf="isFilenameDisplayed">{{ file.name }}</div>
    <div class="file-upload__preview__filesize" *ngIf="isFilesizeDisplayed">{{ file.size | filesize }}</div>
    <div class="file-upload__preview__filetype" *ngIf="isFiletypeDisplayed">{{ file.type }}</div>
    <div class="file-upload__preview__actions">
        <div class="file-upload__preview__actions-container">
            <button euiButton euiRounded euiIconButton euiSizeL euiBasicButton (click)="onRemoveFromList()"><span euiIcon iconClass="eui-icon eui-icon-times"></span></button>
        </div>
    </div>
</div>
